import { __extends } from "tslib";
import { ListTagsForDeliveryStreamInput, ListTagsForDeliveryStreamOutput } from "../models/index";
import { deserializeAws_json1_1ListTagsForDeliveryStreamCommand, serializeAws_json1_1ListTagsForDeliveryStreamCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListTagsForDeliveryStreamCommand = /** @class */ (function (_super) {
    __extends(ListTagsForDeliveryStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListTagsForDeliveryStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListTagsForDeliveryStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: ListTagsForDeliveryStreamInput.filterSensitiveLog,
            outputFilterSensitiveLog: ListTagsForDeliveryStreamOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListTagsForDeliveryStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ListTagsForDeliveryStreamCommand(input, context);
    };
    ListTagsForDeliveryStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ListTagsForDeliveryStreamCommand(output, context);
    };
    return ListTagsForDeliveryStreamCommand;
}($Command));
export { ListTagsForDeliveryStreamCommand };
//# sourceMappingURL=ListTagsForDeliveryStreamCommand.js.map